export default __webpack_public_path__ + "static/media/voidofmadness.4b11bf75.png";